// extracted by mini-css-extract-plugin
export default {"container":"HQh9mI","item":"MtfMaj","icon":"klmdIZ","time":"LdDvYH","label":"fvlojH","item--return":"KG35QZ"};